import React, { useEffect } from "react";
import "./ComingSoon.css";
import { useNavigate } from "react-router-dom";
import CheckIcon from "../../Assets/Products/Icon/Ellipse 1.ico";

function ComingSoon() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cs-container">
      <div className="cs-top-section">
        <div className="cs-badge">COMING SOON</div>
        <h1 className="cs-title">Fulupo Vendor</h1>
        <p className="cs-description">
          Smart vendor management with automated purchase orders, product tracking, and integrated settlements.
        </p>
        <button className="cs-home-btn" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>

      <div className="cs-features-grid">
        <div className="cs-feature-card">
          <img src={CheckIcon} alt="icon" className="cs-feature-icon" />
          <span className="cs-feature-text">Auto Purchase Orders</span>
        </div>
        <div className="cs-feature-card">
          <img src={CheckIcon} alt="icon" className="cs-feature-icon" />
          <span className="cs-feature-text">Stock Syncing</span>
        </div>
        <div className="cs-feature-card">
          <img src={CheckIcon} alt="icon" className="cs-feature-icon" />
          <span className="cs-feature-text">Vendor Analytics</span>
        </div>
        <div className="cs-feature-card">
          <img src={CheckIcon} alt="icon" className="cs-feature-icon" />
          <span className="cs-feature-text">Integrated Billing</span>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
